export default "__VITE_ASSET__71b95b64__"